import script from "./GuestLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuestLayout.vue?vue&type=script&setup=true&lang=ts"

import "./GuestLayout.vue?vue&type=style&index=0&id=0b8a11cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8a11cc"]])

export default __exports__